import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

function Loader({ loading, zIndex }) {
  return (
    <Backdrop
      sx={{
        position: "absolute",
        color: "rgb(245 112 35)",
        zIndex: zIndex || "2",
        filter: "invert(1)",
      }}
      open={loading}
    >
      <CircularProgress
        color="inherit"
        // sx={{
        //   position: "absolute",
        //   transform: "translate(-50%, -50%)",
        //   zIndex: 2,
        //   top: "50%",
        //   left: "50%",
        // }}
        // color="info"
      />
    </Backdrop>
  );
}

export default Loader;
